// extracted by mini-css-extract-plugin
export default {"center":"bP9EGs","messageModalLayout":"C4WvTf","opacityLayer":"r_rEcc"};